import React from 'react';
import './style.scss';

const NoContent = () => {
  return <></>;
};
export default NoContent;
